import './CarouselItem.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

function CarouselItem(props) {
    const descriptions = {
        'Vins': 'Découvrez notre sélection de vins',
        'Softs': 'Des softs rafraîchissants et délicieux',
        'Boissons alcoolisées': 'Une collection exclusive de spiritueux, cocktails et digestifs',
    };

    return (
        <div className='carousel-item' style={{backgroundImage: `url(${props.backgroundImage})`}}>
            <div className='carousel-item-badge'>
                Découvrir
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
            <div className='carousel-item-header'>
                <h3>{props.name}</h3>
                <p>{descriptions[props.name]}</p>
            </div>
        </div>
    )
}

export default CarouselItem;